import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "@/store";
import cache from 'utils/cache'
import { isSsoMode, clearSsoMode } from 'utils/sso'

const Layout = () => import("../components/content/layout")
const Login = () => import("views/login");
const Home = () => import("views/home");
const User = () => import("views/user");
const Profile = () => import("views/profile")
const Notfount = () => import("views/notfount")
const Device = () => import("views/device")
const Feedback = () => import("views/feedback")
const Deviceuser = () => import("views/deviceuser")
const Role = () => import("views/role")
const Menu = () => import("views/menu")
const Adminuser = () => import("views/adminuser")
const Auth = () => import("views/sso/auth.vue");

Vue.use(VueRouter)

export const constRoutes = [
  {
    path: "/",
    name: "/",
    hidden: true,
    meta: {
      title: "登录",
      icon: "home"
    },

    redirect: "/login"
  },
  {
    path: "/login",
    name: "login",
    hidden: true,
    meta: {
      title: "登录",
      icon: "home"
    },
    component: Login
  },

  {
    path: "/auth",
    name: "auth",
    hidden: true,
    meta: {
      title: "统一登录",
      icon: "home"
    },
    component: Auth
  },
  {
    path: "/RMSProfile",
    name: "/RMSProfile",
    hidden: false,
    meta: {
      title: "个人中心",
      icon: "user"
    },
    component: Layout,
    redirect: "/profile",
    children: [
      {
        path: '/profile',
        name: 'profile',
        meta: {
          title: "个人中心"
        },
        component: Profile
      }
    ]
  },

]


//动态路由
export const asyncRoutes = [
]

const createRouter = () => new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),//切换路由始终保持页面顶部
  routes: constRoutes//只挂载静态路由！！
})

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  console.log('resetRouter')
  asyncRoutes.length = 0;
  router.matcher = newRouter.matcher // 重置路由，不同用户菜单权限会有所不同，在切换用户时，会出现菜单错乱的情况
}

export default router

const whiteList = ["/login","/auth"]; //无需令牌白名单

const normalizePath = (p = '') => {
  const s = String(p).trim();
  if (!s) return '/';
  return (s.startsWith('/') ? s : `/${s}`).toLowerCase();
};

let hasAddedRoutes = false; // 标记是否已添加动态路由

router.beforeEach(async (to, from, next) => {
  // console.log('to:{}',to,'from:{}', from)
  // console.log('router:{}',router)
  // next();

  let isSSO = isSsoMode();

  if (to.path === "/login" || to.path === "/auth") {
    resetRouter();
    hasAddedRoutes = false; // 重置标记
  }


  let Token = cache.get("device-Token");

  // 获取令牌判断用户是否登录
  if (Token) {
    //已登录
    const menus = await cache.get("device-menus");
    if (to.path === "/login" || to.path === "/auth") {
      //若已登录没有必要显示登录页，重定向回首页
      const target = menus.length === 0 ? '/rmsprofile' : normalizePath(menus[0].url);
      if (normalizePath(to.path) === target) {
        next();
      } else {
        next({ path: target, replace: true });
      }
      return;
    } else {
      // 去其他路由
      // console.log('asyncRoutes',asyncRoutes)
      const hasRoles = asyncRoutes.length > 0;
      // console.log('hasRoles:{}',hasRoles)

      if (hasAddedRoutes || hasRoles || menus.length === 0) {
        // 若已添加过动态路由，或用户角色已付加，或用户未授权角色，直接放行
        next();
      } else {
        try {
        // 请求获取用户路由并添加这些至路由器
        if (menus.length > 0){
          hasAddedRoutes = true; // 设置标记，防止重复添加
          await menus.forEach((item)=>{
            const url = normalizePath(item.url);
            console.log('加载菜单:', item.name, 'path:', item.path, 'url:', url);
            let menu = {
              path: "/RMS"+url,
              name: "/RMS"+url,
              hidden: false,
              meta: {
                title: item.name,
                icon: item.icon
              },
              component: Layout,
              redirect: url,
              children: [
              {
              path: url,
              component: () => import(`@/views/${item.path}`).catch(err => {
                console.error(`无法加载组件 @/views/${item.path}:`, err);
                throw err;
              }),
              name: item.name,
              meta: {
                title: item.name,
                icon: item.icon,
                roles: [Token]
              }
            }]
          }
          asyncRoutes.push(menu);
          });
          asyncRoutes.push({
            path: '*',
            name: '404',
            hidden: true,
            component: Notfount,
          });
          // console.log('asyncRoutes+++',asyncRoutes)
          router.addRoutes(asyncRoutes);
          // 继续路由切换，确保addRoutes完成
          next({...to, replace: true});
        } else {
          next();
        }
        } catch (error) {
        // 出错需要重置令牌（令牌过期，网络错误等原因）
        //await store.dispatch('user/resetToken')
        // next(`/login?redirect=${to.path}`);
        if (isSSO){
          next(`/auth`);
        } else {
          next(`/login`);
        }
        console.log(error)
        }
      }
    }
  } else {
    //未登录
    if (whiteList.indexOf(to.path) !== -1) {
      // 白名单中的路由路过
      next();
    } else {
      // 重定向至登录页
      if (isSSO){
        next(`/auth`);
      }else {
        next(`/login`);
      }

    }
  }
});
